import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../layouts/Header";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import "../../assets/styles/local/OrderPickingList.css";
import "../../assets/styles/local/asc_Custom_Select_Box.css";
import upArrow from "../../assets/icons/upArrow.png";
import orderPickingFilter from "../../assets/icons/orderPickingFilter.svg";
import smallDownArrow from "../../assets/icons/DownArrowOption.svg";
import calendar from "../../assets/icons/Calendar3.svg";
import { useDispatch, useSelector } from "react-redux";
import AppDatePicker from "../Common/AppDatePicker";
import { FetchStockItemList, addCountStock } from "../../redux/actions/action";
import Pagination from "../Pagination/Pagination";
import { ADD_TO_COUNT_STOCK } from "../../redux/constants/type";
import RouteLeavingGuard from "../Common/RouteLeavingGuard";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const CountStockList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const filter_Popup_Ref = useRef(null);
  const Sortby_Popup_Ref = useRef(null);
  const [single, setSingle] = useState(false);
  const [list, setList] = useState(true);
  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const [openStock, setOpenStock] = useState(false);
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [query, setQuery] = useState("");

  const [filtersPopupShow, setFiltersPopupShow] = useState(false);
  const [listData, setListData] = useState([]);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  // for sort by
  const [shortByArrow, setShortByArrow] = useState(false);
  const [showShortDrop, setShowShortDrop] = useState(false);
  const [sortedLabel, setSortedLabel] = useState("Item Name");
  const [sortedValue, setSortedValue] = useState("itemname");

  // if we want radio check uncheck then make it only one state //
  const [allFilter, setAllFilter] = useState(true);
  const [products, setProducts] = useState(false);
  const [parts, setParts] = useState(false);

  // asc filter status variables....
  const [sentStatus, setSentStatus] = useState("");
  const [productPartValue, setProductPartValue] = useState("");

  // for pagination start
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  // for pagination end

  const fetchItemListRes = useSelector((state) => state.user.fetchStockListRes);
  const AddCountStockRes = useSelector((state) => state.user.addCountStockRes);

  const handleClose = () => setCancelPopupShow(false);
  const [touched, setTouched] = useState(false);

  const handleCancel = () => {
    if (touched) {
      setCancelPopupShow(true);
    } else {
      history.push("/stock-levels-single");
    }
  };

  useEffect(() => {
    fetchScreenTranslations("Stock Levels").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    const sortedPayload = shortByArrow
      ? // ? `asc-${sortedValue}`
        // : `desc-${sortedValue}`;

        `${sortedValue}-asc`
      : `${sortedValue}-desc`;

    const filterPayload = productPartValue;
    dispatch(
      FetchStockItemList(
        sortedPayload,
        filterPayload,
        query,
        perPage,
        currentPage + 1,
      ),
    );
  }, [
    dispatch,
    shortByArrow,
    sortedValue,
    productPartValue,
    currentPage,
    query,
    perPage,
  ]);

  useEffect(() => {
    setCurrentPage(0);
  }, [query, perPage]);

  useEffect(() => {
    if (fetchItemListRes != null && fetchItemListRes?.status) {
      const totalRecords = fetchItemListRes?.data?.totalCount;
      const newTotalPages = Math.ceil(totalRecords / perPage);
      setTotalPages(newTotalPages);
      const tmp = fetchItemListRes?.data?.product;
      const updatedListData = tmp.map((data) => ({
        ...data,
        qtyToPick: data.inStock,
      }));
      setListData(updatedListData);
    }
  }, [fetchItemListRes, query]);

  useEffect(() => {
    if (AddCountStockRes != null && AddCountStockRes?.status) {
      history.goBack();
      dispatch({
        type: ADD_TO_COUNT_STOCK,
        data: {},
      });
    }
  }, [AddCountStockRes]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      filter_Popup_Ref.current &&
      !filter_Popup_Ref.current.contains(event.target)
    ) {
      setFiltersPopupShow(false);
    }

    if (
      Sortby_Popup_Ref.current &&
      !Sortby_Popup_Ref.current.contains(event.target)
    ) {
      setShowShortDrop(false);
    }
  };

  const sortByOption = [
    // { label: "Item Name", value: "itemname" },
    { label: t("Item Name"), value: "itemname" },
    // { label: "Item ID", value: "itemid" },
    { label: t("Item ID"), value: "itemid" },
    // { label: "Client", value: "client" },
    { label: t("Client"), value: "client" },

    // { label: "Aisle", value: "aisl" },
    { label: t("Aisle"), value: "aisl" },

    // { label: "Row", value: "row" },
    { label: t("Row"), value: "row" },

    // { label: "Bin", value: "bin" },
    { label: t("Bin"), value: "bin" },
  ];

  const addStockList = () => {
    const payload = listData
      ?.filter((item) => item.qtyToPick)
      ?.map((item) => ({
        productPartId: item.productPartid,
        qtyCount: item.qtyToPick || 0,
        dateOfCount: startDate.toISOString(),
      }));
    dispatch(addCountStock(payload));
  };
  return (
    <>
      <Header
        leftComponent={
          <div
            className="stock-heading-box"
            style={{ alignItems: "flex-start" }}
          >
            <div
              className="stock-heading cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {t("Stock")}
            </div>
            <div>
              <div className="box-title d-flex flex-column position-relative">
                <div className="d-flex justify-content-between w-100 align-items-center">
                  <span>{t("Stock Levels - Entry")}</span>
                  <img
                    onClick={() => setOpenStock(!openStock)}
                    alt=""
                    src={smallDownArrow}
                    style={{
                      opacity: "60%",
                      width: "18px",
                      height: "12px",
                      transform: openStock ? "rotate(180deg)" : "rotate(0deg)",
                      cursor: "pointer",
                    }}
                  />
                </div>
                {openStock && (
                  <span
                    style={{ top: "36px", left: "0" }}
                    className="box-title align-self-start cursor-pointer  font-weight-normal position-absolute"
                    onClick={() => {
                      history.push("/stock-levels-report");
                    }}
                  >
                    {t("-Stock Levels - Report")}
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex mainSwitch ms-5 pointer">
              <div
                className={
                  single ? "singleSwitch px-4 py-1" : "noSwitch px-4 py-1"
                }
                onClick={() => {
                  setSingle(true);
                  setList(false);
                  history.push("/stock-levels-single");
                }}
              >
                {/* Single */}
                {t("Single")}
              </div>
              <div
                className={list ? "listSwitch px-4 py-1" : "noSwitch px-4 py-1"}
                onClick={() => {
                  setList(true);
                  setSingle(false);
                  history.push("/count-stock-list");
                }}
              >
                {/* List */}
                {t("List")}
              </div>
            </div>
          </div>
        }
        setQuery={setQuery}
      />

      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={() => {
            history.push("/stock-levels-single");
          }}
        />
      )}
      <RouteLeavingGuard
        when={touched}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (touched) {
            if (
              !["/count-stock-single", "/count-stock-list"].includes(
                location.pathname,
              )
            ) {
              return true;
            }
          }
          return false;
        }}
      />
      <div>
        <div className="ps-5 d-flex gap-4 flex-wrap">
          <div className="d-flex align-items-center gap-2">
            <p className="pick_project pt-3">
              {/* Date of Count */}
              {t("Date of Count")}
            </p>
            <div className="align-items-center item-output d-flex border-0 gap-2 ">
              <img
                className="calendarIcon"
                onClick={() => setCalendarIsOpen((p) => !p)}
                src={calendar}
                alt=""
              />
              <AppDatePicker
                inputClassNames={"background-color-transparent"}
                // open={calendarIsOpen}
                selected={startDate}
                onChange={(val) => {
                  setStartDate(val);
                  setCalendarIsOpen(false);
                }}
                onSelect={(d, event) => {
                  event.preventDefault();
                }}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>
          <div
            className="d-flex gap-3 w- pt-3"
            style={{ position: "relative" }}
            ref={Sortby_Popup_Ref}
          >
            <p className="sortBy">
              {/* Sort by */}
              {t("Sort by")}
            </p>
            <img
              className={
                shortByArrow
                  ? "upSortArrow mt-1 pointer"
                  : "downSortArrow mt-1 pointer"
              }
              src={upArrow}
              alt=""
              onClick={() => setShortByArrow(!shortByArrow)}
            />
            <p
              className="datetext pointer"
              onClick={() => setShowShortDrop(!showShortDrop)}
            >
              {sortedLabel ? sortedLabel : "Select"}
            </p>

            <div
              className="sortDropDiv p-3"
              style={{
                transform: showShortDrop ? "scale(1)" : "scale(0)",
                transitionDuration: "300ms",
                width: "max-content",
              }}
            >
              {sortByOption.map((item, index) => {
                return (
                  <div
                    className={
                      sortedLabel === item.label
                        ? "datetext pointer"
                        : "pointer"
                    }
                    onClick={() => {
                      setSortedLabel(item.label);
                      setSortedValue(item.value);
                      setShowShortDrop(false);
                    }}
                  >
                    <p className="d-flex gap-">{item.label}</p>
                  </div>
                );
              })}
            </div>
          </div>

          <div
            className="ps-0 ps-sm-5 pt-3 d-flex gap-2 filterTexts positionForFilterPopup"
            ref={filter_Popup_Ref}
          >
            <p className="ps-0 ps-sm-3">
              {/* Filters */}
              {t("Filters")}
            </p>
            <img
              className="mb-4 pt-1 pointer"
              src={orderPickingFilter}
              alt=""
              onClick={() => setFiltersPopupShow(true)}
            />
            <div className="d-flex gap-0 ps-4">
              <p className="allBorder px-3 pb-4">
                {allFilter ? "All" : parts ? "Parts" : "Products"}
              </p>
              <p
                className="xIconInvoice px-1 pb-4 cursor-pointer"
                onClick={() => {
                  setAllFilter(true);
                  setParts(false);
                  setProducts(false);
                  setSentStatus("");
                  setProductPartValue("");
                }}
              >
                x
              </p>
            </div>

            {/*ASC filter popup start */}
            <section
              className="filterPopup h-auto"
              style={{
                transform: filtersPopupShow ? "scale(1)" : "scale(0)",
                transitionDuration: "300ms",
              }}
            >
              <p
                className="xCiecle ms-auto me-3 mt-1 pointer"
                onClick={() => {
                  setFiltersPopupShow(false);
                }}
              >
                x
              </p>

              <div className="form-check underTexts">
                <input
                  className="form-check-input pointer"
                  style={{ borderRadius: "50%" }}
                  type="checkbox"
                  id="ascInvoice"
                  checked={allFilter}
                  onClick={() => {
                    setAllFilter(!allFilter);
                    setParts(false);
                    setProducts(false);
                  }}
                />
                <label className="form-check-label" for="flexCheckChecked">
                  <p>
                    {/* All */}
                    {t("All")}
                  </p>
                </label>
              </div>

              <div className="form-check underTexts">
                <input
                  className="form-check-input pointer"
                  style={{ borderRadius: "50%" }}
                  type="checkbox"
                  id="ascInvoice"
                  checked={products}
                  onClick={() => {
                    setProducts(!products);
                    setProductPartValue("Product");
                    setAllFilter(false);
                    setParts(false);
                  }}
                />
                <label className="form-check-label" for="flexCheckDefault">
                  <p>
                    {/* Products */}
                    {t("Products")}
                  </p>
                </label>
              </div>

              <div className="form-check underTexts">
                <input
                  className="form-check-input pointer"
                  style={{ borderRadius: "50%" }}
                  type="checkbox"
                  value="Sent"
                  id="ascInvoice"
                  checked={parts}
                  onClick={() => {
                    setParts(!parts);
                    setProductPartValue("Part");
                    setAllFilter(false);
                    setProducts(false);
                  }}
                />
                <label className="form-check-label" for="flexCheckDefault">
                  <p>
                    {/* Parts */}
                    {t("Parts")}
                  </p>
                </label>
              </div>

              <button
                className="clearButton mx-3"
                onClick={() => {
                  setAllFilter(true);
                  setParts(false);
                  setProducts(false);
                  setSentStatus("");
                  setProductPartValue("");
                }}
              >
                {/* Clear */}
                {t("Clear")}
              </button>
            </section>
          </div>

          <div className="ms-auto me-1 me-sm-5 d-flex flex-wrap gap-3 pt-2 threeButtons">
            <button className="mb-0 cancelBtn" onClick={handleCancel}>
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button className="mb-0 makeInvoBtn" onClick={() => addStockList()}>
              {/* Add */}
              {t("Add")}
            </button>
          </div>
        </div>
      </div>

      <div>
        <section className="pt-3">
          <div
            className="ascTableWrapper pt-3 mx-5"
            style={{ borderRadius: "15px" }}
          >
            <table className="table">
              <thead>
                <tr className="tableHeading-NewInvoice">
                  <th> {t("Item Name")}</th>
                  <th> {t("Item ID")}</th>
                  <th> {t("Color")}</th>
                  <th> {t("In Stock")}</th>
                  <th> {t("Aisle")}</th>
                  <th> {t("Row")}</th>
                  <th> {t("Bin")}</th>
                  <th className="text-end" style={{ width: "10%" }}>
                    {t("Qty Counted")}
                  </th>
                </tr>
              </thead>

              <tbody
                className="tabLine"
                style={{ borderTop: "none", background: "white" }}
              >
                {listData.map((item, index) => {
                  return (
                    <tr key={index} className="TableRowClass bg-transparent">
                      <td>
                        <div className="d-flex gap-4 ps-2">
                          <p>{item.productPartName}</p>
                        </div>
                      </td>
                      <td>{item.itemId}</td>
                      <td>
                        <div
                          className="asc_Color_Code"
                          style={{
                            backgroundColor: item.color,
                          }}
                        ></div>
                      </td>
                      <td>{item.inStock}</td>
                      <td>{item.aisl}</td>
                      <td>{item.row}</td>
                      <td>{item.bin}</td>
                      <td
                        className="text-end pe-4"
                        style={{
                          background: "#FAFAFA",
                        }}
                      >
                        <input
                          style={{
                            border: "none",
                            background: "initial",
                          }}
                          className="text-end"
                          type="number"
                          placeholder="0"
                          value={item.qtyToPick}
                          onChange={(e) => {
                            setTouched(true);
                            let data = [...listData];
                            data[index]["qtyToPick"] = e.target.value;
                            setListData(data);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </section>
      </div>
      {listData.length > 0 && (
        <div className="align-text-bottom stock-pagination">
          <Pagination
            perPage={perPage}
            setPerPage={setPerPage}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      )}
    </>
  );
};

export default CountStockList;
